import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	type?: 'danger' | 'warning'
}

export const InfoBox = styled.div<Props>`
	display: flex;
	flex-direction: column;
	background-color: ${({ type = 'action', theme }) => {
		switch (type) {
			case 'danger':
				return theme.color.danger
			case 'warning':
				return theme.color.warning
			default:
				return theme.color.actionLight
		}
	}};
	border-radius: ${helpers.borderRadius};
	padding: 12px 16px;
	color: ${({ theme, type }) => (type === 'danger' ? theme.color.textContrast : theme.color.text)};
	column-gap: ${helpers.spacing.small};
	margin: ${helpers.spacing.large} 0;

	> div:first-child {
		display: flex;
		align-items: flex-start;
		column-gap: 8px;

		> svg {
			flex-shrink: 0;
		}

		> h2, p {
			margin: 0;
		}
	}

	> div:nth-child(2) {
		margin-top: 8px;
	}

	> svg {
		align-self: flex-start;
	}
`
